import React, { memo } from 'react';
import PreNavDropdownProps from './PreNavDropdown.interface';
import { withBlokWrapper } from '../../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../../interfaces/enums/Theme.enum';
import StoryblokLinkProvider from '../../../Utils/StoryblokLinkProvider/StoryblokLinkProvider';
import CustomLink from '../../../CustomLink/CustomLink';

const PreNavDropdown: React.FC<PreNavDropdownProps> = ({ dropdown }) => {
  return (
    <ul
      className={`-left-14 m-auto top-[66px] invisible opacity-0 group-hover:visible group-hover:opacity-100 duration-0 group-hover:duration-[200ms] ease-in-out absolute z-[51] bg-[white] py-8 px-14 space-y-2
      `}
    >
      {dropdown &&
        !!dropdown.length &&
        dropdown.map((item) => (
          <li key={item._uid}>
            {item.link && (
              <StoryblokLinkProvider
                link={item.link}
                render={(link) => (
                  <CustomLink
                    url={link}
                    label={item.label}
                    className="nav-link text-text/body h-full w-full hover:text-text/body-accent text-base flex items-center transition-all whitespace-nowrap py-2"
                  >
                    {item.label && <span className="pr-2">{item.label}</span>}
                  </CustomLink>
                )}
              />
            )}
          </li>
        ))}
    </ul>
  );
};

export default memo(withBlokWrapper(PreNavDropdown, Theme.LIGHT));
